const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ArticleCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.75,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.25,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3.65,
              spacing: 20,
            },
          },
          '(min-width: 1440px)': {
            slides: {
              perView: 4.5,
              spacing: 20,
            },
          },
          '(min-width: 1600px)': {
            slides: {
              perView: 6,
              spacing: 20,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('article-carousel')) {
  customElements.define('article-carousel', ArticleCarousel)
}
